export default __webpack_public_path__ + "static/media/famous.c0cc29a0.svg";